<nav class="breadcrumb-nav" aria-label="Breadcrumb">
  <ol class="breadcrumb-list">
    <li 
      *ngFor="let breadcrumb of breadcrumbs; let last = last" 
      class="breadcrumb-item"
      [class.active]="breadcrumb.isActive">
      
      <ng-container *ngIf="!breadcrumb.isActive; else activeItem">
        <button 
          class="breadcrumb-link"
          (click)="navigateTo(breadcrumb.url)"
          [attr.aria-label]="('breadcrumb.navigateTo' | translate) + ' ' + (breadcrumb.translationKey | translate)">
          <mat-icon *ngIf="breadcrumb.icon" class="breadcrumb-icon">{{ breadcrumb.icon }}</mat-icon>
          {{ breadcrumb.translationKey | translate }}
        </button>
      </ng-container>
      
      <ng-template #activeItem>
        <span class="breadcrumb-current" aria-current="page">
          <mat-icon *ngIf="breadcrumb.icon" class="breadcrumb-icon">{{ breadcrumb.icon }}</mat-icon>
          {{ breadcrumb.translationKey | translate }}
        </span>
      </ng-template>
      
      <svg 
        *ngIf="!last" 
        class="breadcrumb-separator" 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 20 20" 
        fill="currentColor"
        aria-hidden="true">
        <path fill-rule="evenodd" d="M7.21 14.77a.75.75 0 0 1 .02-1.06L11.168 10 7.23 6.29a.75.75 0 1 1 1.04-1.08l4.5 4.25a.75.75 0 0 1 0 1.08l-4.5 4.25a.75.75 0 0 1-1.06-.02Z" clip-rule="evenodd" />
      </svg>
    </li>
  </ol>
</nav>
